import React from 'react';
import { EmailCaptureForm } from '../../components/EmailCaptureForm';
import './LandingPage.css';
import { BsChat, BsLightning, BsStars } from 'react-icons/bs';

export default function GenericLandingPage() {
  return (
    <div className="landing-page">
      <div className="landing-hero" data-fast-scroll="generic_hero_view">
        <img src="/images/GymBuddy.png" alt="GymBuddy" className="landing-logo" onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/images/PokerBuddy.png'; }} />
        <h1 className="landing-title">Your AI Fitness Coach</h1>
        <p className="landing-subtitle">
          Track your food in seconds, get personalized workout plans, and achieve your fitness goals with AI-powered coaching.
        </p>
        
        {/* Hero Image - Part of CTA */}
        <div className="hero-image-container">
          <img src="/images/Injury.png" alt="GymBuddy App Interface" className="hero-image" />
        </div>

        <EmailCaptureForm campaign="general" placeholder="Enter your email" />
      </div>

      <div className="landing-content" data-fast-scroll="generic_benefits_view" data-fast-scroll-threshold="0.5">
        <div className="benefit-grid">
          <div className="benefit-card">
            <div className="benefit-title">
              <BsChat style={{ color: '#213e70' }} />
              <span>Quickest Way to Track Food</span>
            </div>
            <p className="benefit-desc">
              Simply chat what you eat. No more scrolling through databases or weighing food. Just type "Had a chicken salad" and you're done.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsStars style={{ color: '#213e70' }} />
              <span>AI-Powered Training Programs</span>
            </div>
            <p className="benefit-desc">
              Get workout plans that adapt to your progress, schedule, and goals. Our AI learns what works for you and adjusts accordingly.
            </p>
          </div>

          <div className="benefit-card">
            <div className="benefit-title">
              <BsLightning style={{ color: '#213e70' }} />
              <span>Everything in One Place</span>
            </div>
            <p className="benefit-desc">
              Track your nutrition, follow your workouts, monitor your progress photos, and get coaching—all in one simple app.
            </p>
          </div>
        </div>

        <div className="app-preview-section" data-fast-scroll="generic_preview_view">
          <h2 className="app-preview-title">Meet Your New Coach</h2>
          <div className="app-preview-grid">
            <img src="/images/image.png" alt="App Preview 1" className="app-preview-image" />
            <img src="/images/image1.png" alt="App Preview 2" className="app-preview-image" />
            <img src="/images/image3.png" alt="App Preview 3" className="app-preview-image" />
            <img src="/images/image4.png" alt="App Preview 4" className="app-preview-image" />
          </div>
        </div>
      </div>

      <footer className="landing-footer" data-fast-scroll="generic_footer_view">
        © {new Date().getFullYear()} GymBuddy. All rights reserved.
      </footer>
    </div>
  );
}

